<template>
  <div class="pagesafe">
    <XR-head titleText="账户安全" :rightShow="false" ref="headObj"></XR-head>
    <p class="text">帐号安全指数<span>{{memberInfo.AccountSafeLevel}}%</span></p>
    <div class="person-row">
      <div class="person-col person-title">登陆密码</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right" ></mu-icon>
      </div>  
      <router-link to="/usercenter/passwordEdit">
        <div class="person-col person-content">建议定期更换密码</div>  
      </router-link>
    </div>
    <div class="person-row">
      <div class="person-col person-title">手机验证</div>  
      <div class="person-col person-rightIcon">
        <router-link :to="memberInfo.IsTestPhone?'/usercenter/mobileChangeReset':'/usercenter/mobileBind'">
          <mu-icon value=":fa fa-angle-right" style="color:black" ></mu-icon>
        </router-link>
      </div>  
      <router-link :to="memberInfo.IsTestPhone?'/usercenter/mobileChangeReset':'/usercenter/mobileBind'">
        <div class="person-col person-content">{{memberInfo.IsTestPhone?memberInfo.mobile:"未验证"}}</div>  
      </router-link>
    </div>
    <!-- <div class="person-row">
      <div class="person-col person-title">邮箱验证</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right" ></mu-icon>
      </div>  
      <router-link :to="memberInfo.IsTestEmail?'/usercenter/emailChangeReset':'/usercenter/emailBind'">
        <div class="person-col person-content">{{memberInfo.IsTestEmail?memberInfo.email:"未验证"}}</div>  
      </router-link>
    </div> -->
    <div class="person-row">
      <div class="person-col person-title">支付密码</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right" ></mu-icon>
      </div>        
      <router-link :to="memberInfo.IsMpass?'/usercenter/paypasswordEdit':'/usercenter/paypassword'">
        <div class="person-col person-content">{{memberInfo.IsMpass?"已设置":"未设置"}}</div>  
      </router-link>
    </div>
    <div class="person-row">
      <div class="person-col person-title">实名认证</div>  
      <div class="person-col person-rightIcon">
        <mu-icon value=":fa fa-angle-right"></mu-icon>
      </div>  
      <div class="person-col person-content">
        <div class="person-col person-content" v-if="memberInfo.PersonId">已设置</div>  
        <mu-flat-button :label="'未认证'" class="demo-flat-button" @click="openBottomSheet" primary v-if="!memberInfo.PersonId"/>
        <mu-bottom-sheet :open="bottomSheet" @close="closeBottomSheet">
          <mu-row class="pagesafe-cardid">
            <mu-col>
              <mu-text-field label="姓名" v-model="personIdInfo.ReallyName" labelFloat fullWidth/>
            </mu-col>
            <mu-col>
              <mu-text-field label="身份证号" v-model="personIdInfo.PersonId" labelFloat fullWidth/>
            </mu-col>
            <mu-col>
              <mu-raised-button label="确 定" class="demo-raised-button" primary fullWidth @click="SetPersonId()" />
            </mu-col>
          </mu-row>
        </mu-bottom-sheet>
      </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bottomSheet: false,
      personIdInfo:{ 
        ReallyName: '',
        PersonId:''
      },
      memberInfo:{}
    }
  },
  mounted: function(){
    this.getMemberInfo()
  },
  methods: {
    getMemberInfo(){      
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false          
          ths.$refs.XRtoast.hide()
          ths.memberInfo=res.Data
        }
      });      
    },
    closeBottomSheet () {
      this.bottomSheet = false
    },
    openBottomSheet () {
      this.bottomSheet = true
    },
    SetPersonId(){
      this.closeBottomSheet();
      
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/SetPersonId",
        JSON.stringify(this.personIdInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.getMemberInfo()
          ths.$refs.XRtoast.success(res.Msg, true)   
        }
      });
    },

  }
}
</script>
<style>
*{
  margin: 0;
  padding: 0;
}
#app .pagesafe{
  background: white;
}
.pagesafe .person-row{  
  margin: 10px 10px;
  overflow: hidden;
  border-bottom:1px solid #efefef;
}
.pagesafe .person-col{
  float: left;
}
.pagesafe .person-col .fa{
  line-height:48px;
}

.pagesafe .person-title{
  width: 20%;
  line-height: 48px;
  text-align: left;
  text-indent: 10px;
  font-size: 14px;
}
.pagesafe .person-content{
  width: 74%;
  line-height: 48px;
  float: right;
  text-indent: 10px;
  text-align: right;
  color:#ccc;
  font-size: 14px;
}
.pagesafe .person-rightIcon{
  width:6%;
  float: right;
  line-height:none;
}
.pagesafe .person-rightIcon .fa{
  text-align: center;
  line-height:48px;
  font-size: 14px;
}

.pagesafe .text { font-size:16px; text-align:center; padding:32px 0 12px; color:#666;}
.pagesafe .text span { color:Red;}

.pagesafe-cardid {
  padding: 10px 20px 20px 10px;
}
.pagesafe-cardid .demo-raised-button {
  margin-top: 30px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/safe.vue